import React, { lazy, Suspense } from 'react'
import { createPortal } from 'react-dom'

const LazySiteSearchComponent = lazy(() =>
    import(
        '../components/SiteSearchComponent' /* webpackChunkName: "site-search" */
    )
)
const mount = document.getElementById('site-search-container')

const SiteSearch = () => {
    if (!mount) {
        return false
    }

    const algoliaApplicationId = window.React.algolia_application_id
    const algoliaSearchApiKey = window.React.algolia_search_api_key
    const algoliaMerchantIndex = window.React.algolia_merchant_index
    const baseURL = window.React.base_url

    function renderSiteSearch() {
        return (
            <React.Fragment>
                <Suspense fallback={<div>Loading...</div>}>
                    <LazySiteSearchComponent
                        algoliaApplicationId={algoliaApplicationId}
                        algoliaSearchApiKey={algoliaSearchApiKey}
                        algoliaMerchantIndex={algoliaMerchantIndex}
                        baseURL={baseURL}
                    />
                </Suspense>
            </React.Fragment>
        )
    }

    return createPortal(renderSiteSearch(), mount)
}

export default SiteSearch
